var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import FAIcon from '../icons/FAIcon';
import styles from './section.module.scss';
let Section = class Section extends React.Component {
    render() {
        const { store, className, children } = this.props;
        const { icon, title, isOpen, toggle } = store;
        const foldIconClasses = cx('fa', 'muted', { 'fa-chevron-down': !isOpen, 'fa-chevron-up': isOpen }, styles.foldIcon);
        return (React.createElement("div", { className: cx(styles.section, className) },
            React.createElement("div", { className: cx(styles.headerContainer, { [styles.open]: isOpen }), onClick: toggle },
                React.createElement("div", { className: styles.header },
                    React.createElement(FAIcon, { className: cx(styles.icon, icon) }),
                    React.createElement("h2", { className: styles.title }, title)),
                React.createElement(FAIcon, { className: foldIconClasses })),
            React.createElement("div", { className: cx(styles.content, { [styles.hide]: !isOpen }) }, children)));
    }
};
Section = __decorate([
    observer
], Section);
export default Section;
